<template>
  <div class="a-toast a-fix-bottom" :class="[{'a-hidden':!show}, typeClass]">
    <div class="a-toast-close" v-if="showClose" @click="onClickClose"></div>
    <div class="a-toast-msg">{{message}}</div>
  </div>
</template>

<script>
  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      // type: info | error
      type: {
        type: String,
        default: 'error'
      },
      showClose: {
        type: Boolean,
        default: false
      },
      message: {
        type: String,
        default: ''
      },
      onClose: {
        type: Function,
        default: () => {}
      }
    },

    computed: {
      typeClass() {
        return {
          info: '',
          error: 'a-alert',
          success: 'a-success'
        }[this.type] || '';
      }
    },

    methods: {
      onClickClose() {
        this.onClose();
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/ui/base/components/notification.vue